// <s-size-select> — copies the chosen size from a plain <select> into the form's hidden
// input[name="id"], so <s-product-form> can add that variant. The select is `required`,
// so the browser asks shoppers to pick a size before the form can submit.
class SSizeSelect extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const select = this.querySelector('select');
    const input = this.closest('form')?.elements.namedItem('id');
    if (!select || !(input instanceof HTMLInputElement)) return;

    const sync = () => { input.value = select.value; };
    select.addEventListener('change', sync, { signal: this.#ac.signal });
    sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-size-select')) customElements.define('s-size-select', SSizeSelect);
